<template>
  <div class="w-100">
      <Loader class="w-100" :loading="loading">
          <div class=" p-list-representation-wrapper align-items-start">
              <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
                <div class="w-100" >
                  <appHeader></appHeader>
                </div>

                <div class=" row p-list-representation-data w-100">
                  <contentList
                   :loading="loading"
                    :value-modal="valueModal"
                    :show-modal-edit-commission="showModalEditCommission"

                    @submitEditCommission="submitEditCommission"
                    @closeModalCommission="closeModalCommission"

                  ></contentList>
                </div>

              </div>

          </div>

        <tableContent @showModalEditManagementCommission="showModalEditManagementCommission" :page="page" :table-data="tableData" @paganationChangePage="paganationChangePage" :reset-page-paganation="resetPagePaganation" ></tableContent>
      </Loader>
  </div>
</template>

<script>
import contentList from '../components/managementCommissionAndGender/contentList';
import appHeader from '../components/includes/AppHeader';
import tableContent from '../components/managementCommissionAndGender/tableContent';
import addCama from '../modules/addCama.js'
import settings from '../modules/settings';



export default {
  name: "managementCommissionAndGender",
  components: {
    contentList,
    appHeader,
    tableContent,
  },

  props: {

  },

  data() {
    return {
      tableData               : [],
      page                    : 1,
      resetPagePaganation     : 0,
      loading                 : true,
      valueModal              : {},
      showModalEditCommission : false,
      hall_id                 : -1,
      formData                : {
        hall_id                     : -1,
        value_update_system_porsant : '',
      },
      allHour : [],

    }
  },

  watch: {

  },

  created() {

  },


  mounted() {
    const getParamsId = this.$route.params.id;
    this.hall_id      = getParamsId;

    if (typeof(getParamsId) != 'undefined') {
      this.formData.hall_id = this.hall_id;
    }

    this.getHourData();
  },


  methods: {
    getHourData(){
      this.$store
      .dispatch('managementCommissionAndGender/getHour', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        if (res.is_successful) {
          this.allHour = res.data;
          this.getTableData();
        }
        else {
          this.loading   = false;
          this.$message.error(res.message)
        }
      })
    },

    updateTableDataAndProvinceAndCity(page){
      this.loading                                 = true;
      this.formData.page                           = page;
      this.checkRunFirstGetDefaultProvinceAndCity  = 'preventGetProvinceAndCity';
      this.getTableData();
    },

    paganationChangePage(page){
      this.page = page;
      this.updateTableDataAndProvinceAndCity(page);
    },

    getTableData(){
      this.$store
      .dispatch('managementCommissionAndGender/getManagementCommissionAndGender', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        this.loading   = false;
        if (res.is_successful) {
          this.changeStructureDataTable(res.data,this.allHour);
        }
        else {
          this.$message.error(res.message)
        }
      })
    },

    changeStructureDataTable(tableData,allHour){
      const lengthAllHour = allHour.length;

      let dataTable = [];
      for (let i = 0; i < lengthAllHour; i++) {
          const itemTable = {};
          for (let key in tableData) {
            itemTable[key]    = tableData[key][i];
            itemTable.setHour = allHour[i];
          }

          dataTable         = [...dataTable,itemTable]
      }

      this.tableData = dataTable;
    },

    showModalEditManagementCommission(data){
      this.valueModal              = data;
      this.showModalEditCommission = true;
    },

    closeModalCommission(status){
      this.showModalEditCommission = false;
    },

    submitEditCommission(data){
      this.formData                       = data;
      this.formData.hall_id               = this.hall_id;
      this.loading                        = true;

      this.formData.beforeChangeGender           = data.gender;
      this.formData.beforeChangeSystemPorsant    = data.system_porsant;

      this.formData.system_porsant               = data.value_update_system_porsant;
      if (typeof(data.lastGenderChange) != 'undefined') {
        this.formData.gender = data.lastGenderChange;
      }


      this.$store
      .dispatch('managementCommissionAndGender/updateManagementCommissionAndGender', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{

        if (res.is_successful) {
          this.showModalEditCommission = false;
          this.getTableData();
        }
        else {
          this.formData.gender             = this.formData.beforeChangeGender;
          this.formData.system_porsant     = data.beforeChangeSystemPorsant;

          this.loading                 = false;
          this.$message.error(res.message)
        }
      })
    }







  }


}
</script>
